import { AgentFileUploadSchema, LanguageModel } from 'models'

/**
 * Every model an agent can be set to, in the order `LanguageModel` declares
 * them. Derived on purpose: the hand-written copy of this list drifted from the
 * enum twice, leaving models in the dropdown that the gateway had already
 * retired (and, the other way round, ids nobody could select).
 */
export const MODELS = Object.values(LanguageModel)

/**
 * i18n key of a model's display name, under `models.`: the id without its
 * provider prefix and with the version dot dropped (`openai/gpt-5.6-sol` ->
 * `models.gpt-56-sol`).
 *
 * Shared because deriving it twice already drifted: the combobox built the key
 * from the whole id, prefix included, so no option ever found its translation
 * and every label fell back to the raw id. Invisible in the list (both slots
 * render `PkLanguageModel`, which derived the key correctly), but the option
 * search matches on the label, so no model could be found by commercial name.
 */
export const modelLabelKey = (model?: string) =>
    `models.${model?.split('/').pop()?.replace('.', '')}`

export const DEFAULT_TEMPERATURE = 0.6
export const DEFAULT_PROMPT = ''
export const DEFAULT_LIMIT = 5
export const FILE_UPLOAD_DEFAULTS = AgentFileUploadSchema.parse({})
